import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// import Button from '@material-ui/core/Button';
// import TextField from '@material-ui/core/TextField';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
// import Box from '@material-ui/core/Box';
// import { Link } from 'react-router-dom';
import config from 'config/api';
import DynamicForm from 'components/UI/DynamicForm';
import BlockButton from 'components/UI/BlockButton';
// import Paragrapher  from 'components/UI/Paragrapher'
import JobForm from 'components/Registration/JobForm';
import i18n from 'helpers/i18n';
import Immutable from 'immutable';
import LoginForm from 'components/Login/LoginForm';
import ResetPasswordRequestForm from 'components/UI/ResetPassword/ResetPasswordRequestForm';
// import EventSubscriptionRecap from 'components/Event/EventSubscriptionRecap';
// import { formatDate } from 'helpers/stringUtils';
import { connect } from 'react-redux';
import { setCurrentUser } from 'ducks/authentication';
const styles = (theme) => {
  return {
    root: {
      color: theme.palette.primary.main,
      padding: '0 0 10px 0',
      // '& .MuiTypography-body1': {
      // color: '#fff',
      // },
    },
    mainForm: {
      paddingTop: 1,
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    whiteBg: {
      position: 'relative',
      '&:before': {
        position: 'absolute',
        left: 0,
        top: 0,
        content: "' '",
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        opacity: 0.9,
      },
    },
    relative: {
      position: 'relative',
    },
    column: {
      height: '375px',
      '&:nth-of-type(1)': {
        borderRight: '1px #ccc solid',
        [theme.breakpoints.down('sm')]: {
          borderRight: 'none',
          borderBottom: '1px #ccc solid',
          borderTop: '1px #ccc solid',
        },
      },
    },
    padder: {
      padding: '20px 40px',
      margin: '0 30px 20px',
    },
    h2: {
      color: theme.palette.primary.main,
      textAlign: 'center',
      padding: '0 20px 20px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '20px',
      },
    },
    h5: {
      textAlign: 'center',
    },
    h6: {
      fontWeight: 'normal',
    },
    body1: {
      textAlign: 'center',
    },
    recap: {
      '& a': {
        color: theme.palette.primary.main,
      },
    },
    formTitle: {
      textAlign: 'center',
      color: theme.palette.primary.main,
      marginBottom: 30,
      [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
      },
    },
    passwordReset: {
      marginTop: theme.spacing(3),
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  };
};
class RegistrationTwoStepsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // isFormComplete: true,
      showRecap: false,
      logMessage: false,
      step: 1,
      // showRecap: true,
      // logMessage: 'st',
      // step: 2
    };
    // this._onSubscriptionFormComplete = this._onSubscriptionFormComplete.bind(this);
    this._onJobFormComplete = this._onJobFormComplete.bind(this);
    this._onRegistrationComplete = this._onRegistrationComplete.bind(this);
    // this._onRegistrationComplete = this._onFormComplete.bind(this);
    this._onRegistrationCancel = this._onRegistrationCancel.bind(this);
    this._onClose = this._onFormComplete.bind(this);
    this._onLoginFormComplete = this._onFormComplete.bind(this);
    this._onLoginPasswordReset = this._onLoginPasswordReset.bind(this);
    // this._onClose = this._onClose.bind(this);
  }
  //   componentWillUnmount() {
  // }
  // _onSubscriptionFormComplete(responseData) {
  // }
  _onRegistrationCancel() {
    this.setState(
      {
        accountJob: undefined,
        step: 1,
        isNewMember: false,
      },
      () => {
        this.props.onResize();
      },
    );
  }
  _onRegistrationComplete(r) {
    //     const {setCurrentUser} = this.props;
    // console.log('COMPLETE', r)
    //     setCurrentUser(r.user);
    const { showRecap } = this.props;
    if (showRecap === true)
      this.setState(
        {
          showRecap: true,
        },
        () => {
          this.props.onResize();
        },
      );
    else this._onFormComplete(r);
    //     // this.setState({step: 3, newUserRole: r.accountJob});
  }
  _onJobFormComplete(o) {
    this.setState(
      {
        accountJob: o.values.accountJob,
        step: 2,
        isNewMember: true,
      },
      () => {
        this.props.onResize();
      },
    );
  }
  _onLoginPasswordReset() {
    this.setState(
      {
        accountJob: undefined,
        step: 3,
      },
      () => {
        this.props.onResize();
      },
    );
  }
  _onFormComplete() {
    const { onClose, onFormComplete, closeOnComplete } = this.props;
    // console.log('BUBBLED !', onFormComplete)
    const { isNewMember, logMessage, accountJob } = this.state;
    // console.log({
    //   logMessage,
    //   accountJob
    // })
    if (onFormComplete === undefined) {
      onClose();
    } else {
      onFormComplete({
        isNewMember: isNewMember,
        accountJob: accountJob,
      });
      // console.log('b')
      if (closeOnComplete === true) {
        // console.log('c')
        onClose();
      }
    }
  }
  render() {
    const {
      // onClose,
      classes,
      $$event,
      $$events,
      onResize,
      // title,
      // showRecap,
      // extraFields,
    } = this.props;
    //
    const {
      // isFormComplete,
      isNewMember,
      // logMessage,
      showRecap,
      accountJob,
      step,
      logMessage,
    } = this.state;
    const moduleConfig = {
      module: 'account',
      fetchUrl: config.registration + '/edit',
      postUrl: config.registration + '/edit',
      redirectAfterEdit: false,
      afterEdit: 'onFormComplete',
      afterEditLog: '',
      afterEditHideForm: true,
      btCancel: true,
      onFormCancel: this._onRegistrationCancel,
      btCancelLabel: 'Retour',
      btSubmitLabel: 'Envoyer',
    };
    const hiddenFields = ['accountJob'];
    // const hiddenFields = [];
    // const jobCategories = {
    //   md: "isMd",
    //   sf: "isSf",
    //   lb: "isLb",
    //   sf: "isSf",
    //   in: "isIn",
    // };
    const jobCategories = config.getJobsCategories();
    // console.log({ jobCategories });
    const jobCategory = accountJob === undefined ? [] : jobCategories[accountJob];
    let ef = {};
    if ($$event !== undefined && $$event.get('id') !== undefined)
      ef = {
        fromEvent: $$event.get('id'),
      };
    else if ($$events !== undefined && $$events.get(0) !== undefined)
      ef = {
        fromEvents: $$events.map((e) => e.get('id')).toArray(),
      };
    ef.accountJob = accountJob;
    // console.log({showRecap})
    const extraFields = Immutable.fromJS(ef);
    // console.log(step)
    // console.log('DEBUG', $$event, $$events);
    return (
      <div className={classes.root}>
        <If condition={step === 1}>
          <Grid container spacing={0} alignItems="center" justify="space-around">
            <Grid item={true} xs={12}>
              <Box className={classes.whiteBg} py={2} mb={4}>
                <div className={classes.relative}>
                  <Typography
                    variant="h5"
                    gutterBottom={true}
                    color="primary"
                    gutterBottom
                    style={{ marginTop: 10 }}
                  >
                    <If condition={$$event !== undefined || ($$events !== undefined && $$events.size === 1)}>
                      Pour vous inscrire à la réunion, merci de vous identifier, ou de créer un compte
                    </If>
                    <If condition={$$events !== undefined && $$events.size > 1}>
                      Pour vous inscrire à ces réunions, merci de vous identifier, ou de créer un compte
                    </If>
                  </Typography>
                </div>
              </Box>
            </Grid>
            <Grid item={true} xs={12} md={6} className={clsx(classes.column, classes.whiteBg)}>
              <div className={classes.relative}>
                <Typography variant={'h5'} className={classes.formTitle} gutterBottom={true}>
                  {i18n.get('loginFormTitle')}
                </Typography>
                <LoginForm
                  onFormComplete={this._onLoginFormComplete}
                  onPasswordResetRequest={this._onLoginPasswordReset}
                  extraFields={extraFields}
                />
              </div>
            </Grid>
            <Grid item={true} xs={12} md={6} className={clsx(classes.column, classes.whiteBg)}>
              <div className={classes.relative}>
                <Typography variant={'h5'} className={classes.formTitle} gutterBottom={true}>
                  {i18n.get('registrationFormTitle')}
                </Typography>
                <JobForm
                  userRole={undefined}
                  onFormComplete={this._onJobFormComplete}
                  showRequiredLegend={false}
                />
              </div>
            </Grid>
          </Grid>
        </If>
        <If condition={step === 2}>
          {/*<If condition={showRecap !== true}>
          <If condition={i18n.has('registrationFormTitle') === true}>
              <Typography variant={'h4'} className={classes.formTitle} gutterBottom>
                {i18n.get('registrationFormTitle')}
              </Typography>
            </If>
            <If condition={i18n.has('registrationFormInstructions') === true}>
              <Typography variant={'h6'} className={classes.h6} gutterBottom>
                {i18n.get('registrationFormInstructions')}
              </Typography>
            </If>
            <Box align="left">
            <DynamicForm moduleConfig={moduleConfig} onFormComplete={this._onRegistrationComplete} formFooter={<If condition={i18n.has('registrationFormFooter')} ><div>{i18n.get('registrationFormFooter')}</div></If>} extraFields={extraFields} forceHiddenFields={hiddenFields}  onFormCancel={this._onRegistrationCancel} initialCategories={jobCategory}/>

            <br />
                        <Typography variant={'body1'} classes={{root: classes.legend}} gutterBottom>{i18n.get('registrationLogLegend1', {prettyfy: true})}</Typography>
            <hr />
                        <Typography variant={'body1'} classes={{root: classes.legend}} gutterBottom>{i18n.get('registrationLogLegend2', {prettyfy: true})}</Typography>
            </Box>
          </If>
          <If condition={showRecap === true}>
            <Box maxWidth={1024} mx={'auto'} className={classes.recap}>
            <If condition={i18n.has('registrationSuccessTitle')}>
              <Typography variant={'h2'} classes={{root: classes.h2}} gutterBottom>{i18n.get('registrationSuccessTitle', {pretty: true, element: 'div'})}</Typography>
            </If>
            <If condition={i18n.has('registrationSuccessText')}>
              <Typography variant={'h6'} classes={{root: classes.h6}} gutterBottom>{i18n.get('registrationSuccessText', {pretty: true})}</Typography>
            </If>
            <If condition={logMessage === 'x1'}>
              <Typography variant={'body1'} classes={{root: classes.body1}} gutterBottom>{i18n.get('registrationLogStudents', {pretty: true})} </Typography>
            </If>
            <If condition={logMessage !== 'x1'}>
            <Typography variant={'body1'} classes={{root: classes.body1}} gutterBottom>{i18n.get('registrationLogSuccess', {pretty: true})}</Typography>
            </If>


            <BlockButton label="Terminer" onClick={this._onClose} style={{margin: '20px auto 10px', display: 'block'}}/>
            </Box>
          </If>*/}

          <If condition={i18n.has('registrationFormTitle') === true}>
            <Box className={classes.whiteBg} py={2} mb={4}>
              <Typography variant={'h5'} style={{ position: 'relative', marginTop: 0 }}>
                {i18n.get('registrationFormTitle')}
              </Typography>
            </Box>
          </If>
          <If condition={i18n.has('registrationFormInstructions') === true}>
            <Box className={classes.whiteBg}>
              <Typography variant={'h6'} className={classes.h6} style={{ position: 'relative' }}>
                {i18n.get('registrationFormInstructions')}
              </Typography>
            </Box>
          </If>
          <Box align="left" className={clsx(classes.mainForm, classes.whiteBg)}>
            <div className={classes.relative}>
              <DynamicForm
                moduleConfig={moduleConfig}
                onFormReady={onResize}
                onFormComplete={this._onRegistrationComplete}
                formFooter={
                  <If condition={i18n.has('registrationFormFooter')}>
                    <div>{i18n.get('registrationFormFooter')}</div>
                  </If>
                }
                extraFields={extraFields}
                forceHiddenFields={hiddenFields}
                onFormCancel={this._onRegistrationCancel}
                initialCategories={jobCategory}
              />

              <br />
              <Typography variant={'body1'} classes={{ root: classes.legend }} gutterBottom>
                {i18n.get('registrationLogLegend1', { prettyfy: true })}
              </Typography>
              <hr />
              <Typography variant={'body1'} classes={{ root: classes.legend }} gutterBottom>
                {i18n.get('registrationLogLegend2', { prettyfy: true })}
              </Typography>
            </div>
          </Box>
        </If>
        <If condition={step === 3}>
          <div className={classes.whiteBg}>
            <div className={clsx(classes.passwordReset, classes.relative)}>
              <ResetPasswordRequestForm onFormCancel={this._onRegistrationCancel} />
            </div>
          </div>
        </If>
        <If condition={step === 4}></If>
      </div>
    );
  }
}
const mapStateToProps = ($$state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentUser: (user) => {
      dispatch(setCurrentUser(user));
    },
  };
};
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(RegistrationTwoStepsForm));



// WEBPACK FOOTER //
// ./src/components/Registration/RegistrationTwoStepsForm.jsx